class Breadcrumb {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => this._init());
  }

  _init() {
    // Cible le conteneur du fil d'Ariane de Yoast
    const breadcrumbContainer = document.querySelector(
      '.breadcrumb__container'
    );
    if (!breadcrumbContainer) return;
    // Cible les éléments individuels du fil d'Ariane
    const breadcrumbItems = breadcrumbContainer.querySelectorAll('span > span');
    // On ne fait rien si le fil d'Ariane est déjà court
    if (breadcrumbItems.length <= 4) return;

    // On définit le point de rupture : la logique s'appliquera sous cette largeur.
    // 768px est une valeur courante pour cibler tablettes et mobiles.
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    // On exécute la fonction une première fois au chargement de la page
    this._handleBreadcrumbDisplay(
      mediaQuery,
      breadcrumbContainer,
      breadcrumbItems
    );

    // Et on la ré-exécute à chaque fois que la taille de l'écran passe le point de rupture
    mediaQuery.addEventListener('change', (e) =>
      this._handleBreadcrumbDisplay(e, breadcrumbContainer, breadcrumbItems)
    );
  }

  // Fonction principale qui gère l'affichage du fil d'Ariane
  _handleBreadcrumbDisplay(
    query: MediaQueryList | MediaQueryListEvent,
    breadcrumbContainer: Element,
    breadcrumbItems: NodeListOf<Element>
  ) {
    // D'abord, on réinitialise l'affichage à son état d'origine
    // C'est essentiel pour que ça fonctionne bien si on redimensionne la fenêtre
    const existingEllipsis = breadcrumbContainer.querySelector(
      '.breadcrumb-ellipsis-toggle'
    );
    if (existingEllipsis) existingEllipsis.remove();

    breadcrumbContainer
      .querySelectorAll('.hidden-separator')
      .forEach((wrapper) => {
        // Move the text node back out of the wrapper
        if (wrapper.firstChild) {
          wrapper.parentNode?.insertBefore(wrapper.firstChild, wrapper);
        }
        // Remove the now-empty wrapper
        wrapper.remove();
      });

    breadcrumbContainer
      .querySelectorAll('.breadcrumb-item-hidden')
      .forEach((el) => {
        (el as HTMLElement).style.display = ''; // Rétablit l'affichage
        el.classList.remove('breadcrumb-item-hidden');
      });

    // --- SI L'ÉCRAN EST ÉTROIT (MOBILE) ---
    if (query.matches) {
      // On crée les "..." cliquables
      const ellipsis = document.createElement('span');
      ellipsis.innerHTML = '/ &nbsp;<strong>...</strong>';
      ellipsis.className = 'breadcrumb-ellipsis-toggle';
      ellipsis.style.cursor = 'pointer';
      ellipsis.title = 'Afficher le chemin complet';

      // On cache les éléments du milieu et on leur ajoute une classe
      const hiddenElements: HTMLElement[] = [];
      for (let i = 2; i < breadcrumbItems.length - 1; i++) {
        const item = breadcrumbItems[i] as HTMLElement;
        item.style.display = 'none';
        item.classList.add('breadcrumb-item-hidden');
        hiddenElements.push(item);

        // On cache aussi le séparateur qui suit
        if (item.nextSibling && item.nextSibling.nodeType === Node.TEXT_NODE) {
          const separatorWrapper = document.createElement('span');
          separatorWrapper.className = 'hidden-separator';
          separatorWrapper.style.display = 'none';
          // Store a reference to the text node
          const textNode = item.nextSibling;
          // Insert the wrapper before the text node
          item.parentNode!.insertBefore(separatorWrapper, textNode);
          // Move the text node inside the wrapper
          separatorWrapper.appendChild(textNode);
          hiddenElements.push(separatorWrapper);
        }
      }

      // On insère les "..." après le deuxième élément
      const secondItem = breadcrumbItems[1];
      secondItem.parentNode!.insertBefore(ellipsis, secondItem.nextSibling);

      // On ajoute l'événement au clic sur les "..."
      ellipsis.addEventListener(
        'click',
        function () {
          hiddenElements.forEach((el) => (el.style.display = ''));
          ellipsis.remove();
        },
        { once: true }
      );
    }
    // --- SI L'ÉCRAN EST LARGE, on ne fait rien de plus, tout est déjà réinitialisé ---
  }
}

export const breadcrumb = new Breadcrumb();
